import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

import objectToFormData from 'object-to-formdata';


//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiMermeny,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
	},

	computed: {
	},

	watch: {
	},

	methods: {

		// Denna genererar mermenyn för en (1) enskild bestämd användare:
		menyConfigForEnAnvandare(anv)
		{
			const mc = new euiPopUpMenyClasses.menyConfig([
					new euiPopUpMenyClasses.delEvent('Impersonera (kör som)', 'impersoneraAnvandare', {
						ikon: 'impersonera',
						disabled: anv.Id === this.currentUser,
						tooltip: (anv.Id === this.currentUser ? 'Du kan inte impersonera dig själv, dummer!' : undefined),
						eventData: anv,
					}),
				]);

			return mc;
		},

		//======================================================================================================================================

		onMenyalternativValt({ eventId, eventData }) {
			switch (eventId) {
				case 'impersoneraAnvandare':
					{
						console.log(`Impersonering av ${eventData.Email} inledd.`);

						this.AjaxpostaOchHanteraResultat('/impersonate', {
							formData: objectToFormData({ personId: eventData.Id }),
							//doljSpinnerOnSuccess: false,
							onSuccessFunction: (resultat) => {

							// Gå till översiktssidan
							window.location.href = '/';							},
						});

						break;
					}
			}
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	},

	mounted()
	{
		// Programmatisk bind:
		//this.$on('knapp-tryckt-i-meddelandedialog', this.onKnappTrycktIMeddelandedialog);
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!

// Görs nu i ssoAllaSidorMixin:
//console.time('#TIMING: initieraTooltips');	// Todo: TEMP!!!
//ssoTooltips.initiera(document.body);
//console.timeEnd('#TIMING: initieraTooltips');	// Todo: TEMP!!!

export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;


